export const ADD_RISORSA = 'ADD_RISORSA';
export const REMOVE_RISORSA = 'REMOVE_RISORSA';